import { Injectable } from '@angular/core';
import { Category } from '../../../core/models/administration/global-codes/category';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONFIG } from '../../../core/config';
import { ExceptionService } from '../../../core/services/exception.service';
import { catchError, finalize } from 'rxjs/operators';
import { PagedResultModel } from '../../../core/models/paged-result.model';
import { SpinnerService } from '../../../core/spinner/spinner.service';
import { CategoryQuery } from '../../../core/models/administration/global-codes/category-query';
import { IconsModel } from '../../../core/models/administration/global-codes/icons';

@Injectable({
    providedIn: 'root'
})
export class CategoryService {

    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    getAllCategories(categoryQuery: CategoryQuery): Observable<PagedResultModel> {

        let headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this._spinnerService.show();
        return this._http.post<PagedResultModel>(CONFIG.baseUrls.admin.globalCodes.getAllCategories, categoryQuery, headers)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getCategoryByID(id: number, langID: number): Observable<Category> {
        this._spinnerService.show();
        return this._http.get<Category>(CONFIG.baseUrls.admin.globalCodes.getCategoryByID + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    saveCategory(data: Category): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.globalCodes.saveCategory, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getIcons(langID: number): Observable<any> {
        this._spinnerService.show();
        return this._http.get<any>(CONFIG.baseUrls.admin.globalCodes.getIcons + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    deleteCategoryByID(id: number): Observable<any> {
        this._spinnerService.show();
        return this._http.delete<any>(CONFIG.baseUrls.admin.globalCodes.deleteCategoryByID + id)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

}
